import { Typography } from '@mui/material';
import { useAppSelector } from 'app/hooks';

import { disciplinaInfoSelector } from '#modules/disciplinas/redux/disciplinaInfoSlice';

import { BoxInfo } from './styles';

export function PlanoEnsinoArtigos() {
  const disciplina = useAppSelector(disciplinaInfoSelector.disciplina);

  if (disciplina == null || disciplina.artigos == null || disciplina.artigos === '') return <></>;

  return (
    <BoxInfo id="artigos">
      <header>
        <Typography>ARTIGOS</Typography>
      </header>

      <div dangerouslySetInnerHTML={{ __html: disciplina.artigos }} />
    </BoxInfo>
  );
}
